import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala/sections/sections/Services";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala/sections/sections/ArticleContent";

function CuratenieGenerala() {
    return (
        <>
            <Helmet>
                <title>Curățenie generală profesională | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Servicii profesionale de curățenie generală pentru apartamente, case, birouri și spații comerciale. Solicită o evaluare gratuită."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-generala/" />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "FAQPage",
                      "mainEntity": [
                        {
                          "@type": "Question",
                          "name": "Cât durează o curățenie generală profesională?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Durata depinde de suprafață, gradul de murdărie și serviciile incluse. După evaluare, se poate estima un interval clar de timp pentru intervenție."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Ce diferență este între curățenia generală și cea de întreținere?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Curățenia generală este mai amplă și acoperă inclusiv zonele unde murdăria se adună în timp. Curățenia de întreținere este periodică și are rolul de a păstra rezultatele obținute."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Se poate face curățenie generală și în birouri sau spații comerciale?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da. Serviciul poate fi adaptat pentru birouri, magazine, showroom-uri și alte spații comerciale, în funcție de program și de specificul locației."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Trebuie să asigur eu produsele și echipamentele de curățenie?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "În mod normal, o firmă de curățenie vine pregătită cu echipamente și soluții potrivite. Detaliile exacte se stabilesc la ofertare."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Cum se stabilește prețul pentru curățenie generală?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Prețul se calculează în funcție de suprafață, tipul spațiului, gradul de murdărie și eventualele servicii suplimentare incluse."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Este potrivită curățenia generală după renovări ușoare sau înainte de mutare?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da. Sunt printre cele mai frecvente situații în care acest serviciu este solicitat, pentru că ajută la pregătirea rapidă și completă a spațiului."
                          }
                        }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CuratenieGenerala;
